$(document).ready(function () {

    const locations = [];
    const selectedItems = [];
    const searchboxInput = $("#searchbox-input");
    const optionsContainer = $("#searchbox-options");
    const searchboxList = $("#searchbox-list");
    const noResults = $("#no-results");
    const selectedItemsContainer = $("#selected-items");
    const searchRadius = $("#search-radius");

    function renderOptions(filteredAreas) {
        searchboxList.empty();
        if (filteredAreas.length === 0) {
            noResults.show();
        } else {
            noResults.hide();
            filteredAreas.every((area, index) => {
                if (index === 10) {
                    return false;
                }
                const li = $("<li>")
                    .addClass("group flex w-full flex-col cursor-default flex-start rounded-md px-2 py-1.5 transition-colors hover:bg-gray-100 cursor-pointer")
                    .text(area.value)
                    .data("area", area);

                li.append('<span class="text-sm text-gray-400  group-hover:text-gray-500 capitalize">' + area.parent_label + '</span>');

                li.on("click", function () {
                    selectArea(area);
                    searchboxInput.val("");
                    renderOptions([]);
                });

                searchboxList.append(li);
                return true;
            });
        }
    }

    function selectFirstOption() {
        const firstOption = searchboxList.find("li").first();
        if (firstOption.length) {
            firstOption.click();
        }
    }

    function selectArea(area) {
        if (!selectedItems.find((item) => item.value === area.value)) {
            selectedItems.push(area);
            renderSelectedItems();
            updateHiddenInput();
            toggleSearchRadius();
        }
    }

    function toggleSearchRadius() {
        if (selectedItems.length > 1 || selectedItems.find((item) => ['postcode', 'province'].includes(item.type))) {
            searchRadius.value = 0;
            searchRadius.find('option').prop('selected', false);
            searchRadius.hide();
        } else {
            searchRadius.show();
        }
    }

    function removeSelectedItem(area) {
        const index = selectedItems.findIndex((item) => item.value === area.value);
        if (index !== -1) {
            selectedItems.splice(index, 1);
            renderSelectedItems();
            updateHiddenInput();
            toggleSearchRadius();

        }
    }

    function renderSelectedItems() {
        selectedItemsContainer.empty();
        selectedItems.forEach((item) => {
            const selectedItem = $("<span>")
                .addClass("bg-primary text-white px-3 py-1 rounded-lg text-sm flex items-center gap-2")
                .text(item.value);

            const removeButton = $("<button>")
                .addClass("text-red-600 hover:text-red-800")
                .html("&times;")
                .on("click", function () {
                    removeSelectedItem(item);
                });

            selectedItem.append(removeButton);
            selectedItemsContainer.append(selectedItem);
        });
        if (selectedItems.length > 0) {
            selectedItemsContainer.addClass('flex');
            selectedItemsContainer.removeClass('hidden');
        } else {
            selectedItemsContainer.removeClass('flex');
            selectedItemsContainer.addClass('hidden');
        }
    }

    function updateHiddenInput() {
        const selectedData = selectedItems.map((item) => {
            return `${item.value}|${item.type}`;
        }).join(',');
        $("#selected-areas-input").val(selectedData); // Sla ze op als een JSON-string
    }

    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    function fetchLocations(query) {
        if (query.length < 1) {
            return Promise.resolve([]);
        }
        return $.ajax({
            url: "/api/locations/get", // API-route
            method: "GET",
            data: {query: query},
        });
    }

    function filterLocations(query) {
        let filtered = locations.filter((area) => area.value.toLowerCase().includes(query));
        //also search in synonyms
        locations.forEach((area) => {
            if (area.synonyms) {
                area.synonyms.forEach((synonym) => {
                    //only add if not already in the list
                    if (filtered.find((a) => a.value === area.value)) {
                        return;
                    }
                    if (synonym.toLowerCase().includes(query)) {

                        filtered.push(area);
                    }
                });
            }
        });
        return filtered;
    }

    const debouncedFetchLocations = debounce(function (query) {
        if (locations.length > 0) {
            renderOptions(filterLocations(query));
            optionsContainer.show();
        } else {
            fetchLocations(query)
                .then(function (data) {
                    locations.push(...data);
                    renderOptions(filterLocations(query));
                    optionsContainer.show();
                })
                .catch(function () {
                    console.error("Error fetching locations");
                });
        }
    }, 300);


    searchboxInput.on("input", function () {
        const query = $(this).val().toLowerCase();
        if (!query) {
            optionsContainer.hide();
            return;
        }
        debouncedFetchLocations(query);
    });
    searchboxInput.on("keydown", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            selectFirstOption();
            $(this).closest("form").submit();
        }
    });

    $(document).on("click", function (e) {
        if (!$(e.target).closest('#searchbox-input').length) {
            optionsContainer.hide();
            searchboxInput.val("");
        }

    });

    function setSelectedAreasByQueryString() {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        let selectedAreasParam = urlParams.get('selected_areas');
        let selectedAreas = selectedAreasParam ? decodeURIComponent(selectedAreasParam).split(',') : [];

        selectedAreas.forEach((area) => {
            const [value, type] = area.split('|');
            selectedItems.push({value, type});
        });
        let searchRadiusParam = urlParams.get('search_radius');
        if (searchRadiusParam) {
            searchRadius.val(searchRadiusParam);
        }

        updateHiddenInput();
        renderSelectedItems();
        toggleSearchRadius();
    }

    renderOptions([]); // Initialize with all options
    setSelectedAreasByQueryString();
});
